import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationNotYetOpenError extends ExpectedError {
  static override _class = 'RegistrationNotYetOpenError';

  public constructor() {
    super('RegistrationNotYetOpenError', {
      translationKey: 'REGISTRATION_NOT_YET_OPEN_ERROR',
    });
  }
}
